import type { App } from 'vue'
import ZsDialog from '@/elements/ZsDialog.vue'
import CusTip from '@/elements/CusTip.vue'
import DeleteConfirmDialog from '@/components/DeleteConfirmDialog/DeleteConfirmDialog.vue'

export default (app: App): void => {
  //   app.use(plugin)

  app.component('zs-dialog', ZsDialog)
  app.component('cus-tip', CusTip)
  app.component('delete-confirm-dialog', DeleteConfirmDialog)
}
